import React from 'react';
import { EducationList } from '../components/EducationList';
import { PageHeader } from '../components/PageHeader';
export function Education() {
  return <>
      <PageHeader eyebrow="Education" title="Academic foundation in journalism, education and business." intro="Distinguished alumnus of both Oklahoma State University and the University of Central Oklahoma, with continued service on advisory boards at each." data-id="element-300" data-mp="1epwpf6bm808c" />
      <EducationList data-id="element-301" data-mp="zwjss6eiozqp" />
    </>;
}